module.exports = __webpack_public_path__ + "img/finish-en.878d9dee.png";